// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__9YAxY","inner":"Form_inner__wlMyF","range":"Form_range__15DPG","name":"Form_name__822xk","actions":"Form_actions__1EUgb"};